package com.eladfinish.bible.contest.screens.search.ui

/**
 * Developed by
 * @author Elad Finish
 */

enum class HighlightType {
    ASTERISKS,
    BRACKETS,
    NONE,
}

fun HighlightType.toHighlightSigns(): Pair<String, String> =
    when (this) {
        HighlightType.ASTERISKS -> "*" to "*"
        HighlightType.BRACKETS -> "[" to "]"
        HighlightType.NONE -> "" to ""
    }

fun String.wrapWithSigns(type: HighlightType) =
    type.toHighlightSigns().let { it.first + this + it.second }
